module.exports = __webpack_public_path__ + "static/media/repeat-white.a7395b0d.svg";